import { render, staticRenderFns } from "./MassMessageEdit.vue?vue&type=template&id=777d3ea3&scoped=true&"
import script from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
export * from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageEdit.vue?vue&type=style&index=0&id=777d3ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777d3ea3",
  null
  
)

export default component.exports